var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4671_77416)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4671_77416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 54.9879C110 67.9206 105.536 79.8158 98.0807 89.2016C87.9952 101.869 72.4567 110 55.0121 110C37.5674 110 22.0048 101.869 11.9434 89.2016C4.4637 79.8158 0 67.9206 0 54.9879C0 42.0553 4.4637 30.1843 11.9193 20.7984C15.1524 16.7449 18.9406 13.1257 23.1871 10.1097C32.1869 3.73986 43.1652 0 54.9879 0C66.8348 0 77.8131 3.73986 86.7888 10.1097C91.0353 13.1257 94.8234 16.7449 98.0566 20.7984C105.536 30.1843 110 42.0794 110 54.9879Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00938 9.90255C1.9017 9.8323 0.110161 11.4833 0.00477701 13.591C-0.100607 15.6987 1.55041 17.4902 3.69323 17.5956C5.80092 17.701 7.62758 16.05 7.69784 13.9423C7.76809 11.8346 6.11707 10.0079 4.00938 9.90255Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87873 2.20212C7.67628 2.13889 6.63205 3.11887 6.6004 4.32014C6.56876 5.52141 7.48642 6.56462 8.68887 6.59623C9.89132 6.65946 10.9356 5.71109 10.9988 4.50982C11.0305 3.27694 10.0812 2.23373 8.87873 2.20212Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.679 98.0029C106.478 97.9397 105.435 98.9197 105.403 100.121C105.34 101.322 106.289 102.365 107.49 102.397C108.691 102.46 109.734 101.512 109.797 100.311C109.861 99.1093 108.912 98.0661 107.679 98.0029Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.138 103.703C100.489 103.621 99.0862 104.934 99.0037 106.576C98.9212 108.218 100.214 109.613 101.864 109.695C103.513 109.778 104.943 108.491 104.998 106.85C105.053 105.208 103.788 103.758 102.138 103.703Z",
    fill: "#E4F0FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4671_77416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4185 78.1346L24.4185 88.5806C23.9999 90.7068 26.0464 92.5094 28.1395 91.8623L39.6278 88.2108C45.1162 90.753 51.3953 91.9547 57.9534 91.4463C75.9069 90.0597 90.465 75.6387 91.9069 57.7973C93.7208 35.0565 74.7441 16.1983 51.8139 18.1396C34.0464 19.6187 19.6278 33.901 18.1395 51.5575C17.2557 61.6799 20.5115 71.0166 26.4185 78.1346Z",
    fill: "url(#paint0_linear_4671_77416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.627 54.0525C29.627 68.1037 41.0688 79.4741 55.2083 79.4741C69.3479 79.4741 80.7897 68.1037 80.7897 54.0525C80.7897 40.0013 69.3479 28.6309 55.2083 28.6309C41.0688 28.6309 29.627 40.0013 29.627 54.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6641 63.6059L43.0251 57.4296C41.354 55.8586 41.2539 53.226 42.7595 51.5301C44.3169 49.8373 46.921 49.7306 48.5953 51.2493L52.2354 54.6193L61.2859 45.0227C62.8432 43.3299 65.496 43.2787 67.1153 44.8466C68.7864 46.4176 68.8315 49.0994 67.2773 50.7399L55.4417 63.4267C53.8876 65.0672 51.3384 65.1246 49.6641 63.6059Z",
    fill: "url(#paint1_linear_4671_77416)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4671_77416",
    x1: 36.9151,
    y1: 73.4974,
    x2: 75.6771,
    y2: 25.8286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4671_77416",
    x1: 48.135,
    y1: 59.0211,
    x2: 59.8122,
    y2: 43.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5261C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4671_77416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4671_77416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4671_77416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCheck);
export default __webpack_public_path__ + "static/media/modal-check.641dee172cda96d987be145a44a0cd79.svg";
export { ForwardRef as ReactComponent };